import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withSagas } from 'decorators/Sagas';
import { checkoutOffer, watchOfferCheckout } from './OfferCheckout.saga';

export const mapDispatchToProps = {
  checkoutOffer,
};

export class OfferCheckoutUnwrapped extends PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(...args) {
    const { checkoutOffer: localCheckoutOffer, onClick, promotionAlias } = this.props;

    if (onClick) {
      onClick(...args);
    }

    localCheckoutOffer(promotionAlias);
  }

  render() {
    const { className, children } = this.props;

    return (
      <span className={classNames('qa-button', className)} onClick={this.handleClick}>
        {children}
      </span>
    );
  }
}

OfferCheckoutUnwrapped.propTypes = {
  checkoutOffer: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  promotionAlias: PropTypes.string.isRequired,
};

const reduxDecorator = connect(null, mapDispatchToProps);
const sagaDecorator = withSagas({ watch: watchOfferCheckout });

export const OfferCheckout = sagaDecorator(reduxDecorator(OfferCheckoutUnwrapped));
